var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 4.60625C0 3.16875 1.16875 2 2.60625 2H29.3937C30.8312 2 32 3.16875 32 4.60625C32 5.20625 31.7938 5.7875 31.4125 6.25L21 19.0312V27.9813C21 29.0938 20.0938 30 18.9813 30C18.525 30 18.0813 29.8438 17.725 29.5625L11.9438 24.975C11.3438 24.5 11 23.7812 11 23.0187V19.0375L0.5875 6.25C0.20625 5.7875 0 5.20625 0 4.60625ZM3.4375 5L13.6625 17.55C13.8813 17.8187 14 18.15 14 18.5V22.775L18 25.95V18.5C18 18.1562 18.1187 17.8187 18.3375 17.55L28.5625 5H3.4375Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c255bd1ed6812fe12950f58f4acb1170.svg";
export { ForwardRef as ReactComponent };